/**
 * 廃止ドメイン一覧。
 * router/index.js の beforeEach で参照され、該当ホストへのアクセスは
 * 404 ページへ遷移される。
 */
export const LEGACY_HOSTS = [
  'almex-precheckin-dev.an.r.appspot.com',
  'almex-precheckin-stg.an.r.appspot.com',
  'almex-precheckin-prd.an.r.appspot.com',
  'laravel-dot-almex-precheckin-dev.an.r.appspot.com',
  'laravel-dot-almex-precheckin-stg.an.r.appspot.com',
  'laravel-dot-almex-precheckin-prd.an.r.appspot.com',
]

/**
 * 与えられた hostname が廃止ドメインに該当するかを返す。
 *
 * @param {string} hostname
 * @returns {boolean}
 */
export function isLegacyHost(hostname) {
  return LEGACY_HOSTS.includes(hostname)
}
